import { ApplicationRootState } from 'types';
import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the groupsPage state domain
 */

const selectGroupsPageDomain = (state: ApplicationRootState) => {
  return state ? state.groupsPage : initialState;
};

/**
 * Other specific selectors
 */

/**
 * Default selector used by GroupsPage
 */

const selectGroupsPage = () =>
  createSelector(selectGroupsPageDomain, substate => {
    return substate;
  });

export default selectGroupsPage;
export { selectGroupsPageDomain };
